import { Injectable, inject } from '@angular/core';
import {
  CommunityItem,
  PartnerPlatforms,
  PartnerPlatformsMap,
  PostTypes,
  SOCIAL_MEDIA_ICONS,
  SOCIAL_MEDIA_ICON_SIZES,
  SocialMediaPlatform,
} from '../interfaces';
import { CommunityConfigService } from './util/community-config.service';
import { PartnerApp } from '../interfaces/partner';
import { IconName } from '@outlaw/icons';

@Injectable({
  providedIn: 'root',
})
export class AppPlatformService {
  private communityConfig = inject(CommunityConfigService);

  getSourceLogo(item: CommunityItem): IconName | '' {
    const platform = this.getOriginalPlatform(item);
    const isRepost = item.post_type.slug === PostTypes.repost;
    const postType = isRepost ? item.content.community_repost?.original?.original_type : item.post_type.slug;

    switch (postType) {
      case PostTypes.socialPost:
        if (!item.content.social_media && !isRepost) {
          return '';
        }

        return SOCIAL_MEDIA_ICONS[platform] || '';
      case PostTypes.likedPlaylist:
      case PostTypes.likedVideo:
      case PostTypes.post:
        const isPartnerPlatform = PartnerPlatforms.includes(platform);
        const partnerApp = this.getAppByPlatform(platform);

        if (isPartnerPlatform && this.communityConfig.currentApp !== partnerApp) {
          return SOCIAL_MEDIA_ICONS[platform] || '';
        }

        return '';
      default:
        return '';
    }
  }

  getSourceLogoSize(item: CommunityItem): { width: number; height: number } | null {
    const platform = this.getOriginalPlatform(item);
    return SOCIAL_MEDIA_ICON_SIZES[platform] || null;
  }

  getAppByPlatform(platform: SocialMediaPlatform): PartnerApp | null {
    const isPartnerPlatform = PartnerPlatforms.includes(platform);
    const partnerApp = PartnerPlatformsMap.get(platform);

    return isPartnerPlatform && partnerApp ? partnerApp : null;
  }

  getSocialMediaUrl(item: CommunityItem): string {
    const content = item.content;

    return content.social_media?.external_url || content.repost?.source?.source_url;
  }

  getOriginalPlatform(item: CommunityItem): SocialMediaPlatform {
    return item.original_platform.slug.toLowerCase() as SocialMediaPlatform;
  }
}
